import View from 'girder/views/View';
import AnalysisOptionsDialogTemplate from '../../templates/widgets/analysisOptionsDialog.pug';
import '../../stylesheets/widgets/analysisOptionEntry.styl';

import 'girder/utilities/jquery/girderModal';

import { startAnalysis } from './AnalysesMenuWidget';


/**
 * This view shows a dialog container detailing Analysis extra options.
 */
var AnalysisOptionsWidget = View.extend({
    events: {
        'click button.g-start-analysis': 'getAnalysisOptions',
    },

    initialize: function (settings) {
        this._fetchAndInit(settings);
    },

    render: function () {
        if (this.showWidget) {
            this.$el.html(AnalysisOptionsDialogTemplate({
                model: this.model,
                analysisName: this.analysisName,
                analysisExtraOpts: this.analysisExtraOpts,
            })).girderModal(this);
        }
        return this;
    },

    update: function (settings) {
        this._fetchAndInit(settings);
        this.render();
    },

    getAnalysisOptions: function (e) {
        $(e.currentTarget).girderEnable(false);
        let options = {};
        _.each(this.$('.g-options-list'), function (el) {
            var option = $(el).find('.g-entry-col-right>select');
            options[option.attr('id')] = option.val()
        }, this);
        this.parentView.startAnalysis(options);
    },

    _fetchAndInit: function (params) {
        this.analysisName = params.analysisName;
        this.analysisExtraOpts = params.analysisExtraOpts;
        this.showWidget = this.analysisExtraOpts && this.analysisExtraOpts.length;
    },
});

export default AnalysisOptionsWidget;




// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/widgets/AnalysisOptionsWidget.js